function hasErrors(fieldsError) {
  return fieldsError
    ? Object.keys(fieldsError).some(field => fieldsError[field])
    : false;
}
/*
function getCompany(subject, company) {
  switch (subject) {
    case 'legal':
      return `ЮЛ, ${company.nameLegal}`;
    case 'physical':
      return `ФЛ, ${company.lastname} ${company.name && company.name[0]}. `;
    case 'individ':
      return company.nameLegal;
    default:
      return null;
  }
}
*/

const progresses = {};

progresses.default = [
  {
    title: 'Общие Параметры',
    name: 'main',
    completed: false,
    fields: [
      'registerSignAndRegion',
      'brand',
      'model',
      'vehicleType',
      'productionYear',
      'category',
      'passengerCapacity',
    ],
    check: (values, form) => {
      return !hasErrors(
        form.getFieldsError([
          'registerSignAndRegion',
          'brand',
          'model',
          'vehicleType',
          'productionYear',
          'category',
          'passengerCapacity',
        ])
      ) &&
        values.registerSignAndRegion &&
        values.brand &&
        values.model &&
        values.vehicleType &&
        values.productionYear &&
        values.category &&
        values.passengerCapacity
        ? true
        : false;
    },
    getDescription: (values, { brandsTypes }) => {
      const brandId = +values.brand;
      let brand =
        brandsTypes &&
        brandsTypes.find(item => item.vehicleBrandId === brandId);
      return (
        (brand ? brand.brandName + ', ' : '') + values.registerSignAndRegion
      );
    },
  },
  {
    title: 'Дополнительные параметры',
    name: 'additional',
    fields: [
      'vin',
      'osagoNum',
      'osagoValidUntilDate',
      'color',
      'steeringArrangement',
      'driveUnitType',
      'engineVolume',
      'engineCapacity',
      'vehicleMaxWeight',
      'vehicleWeight',
      'doorsAmount',
      'garageNum',
      'tachograph',
      'gps',
      'diagnosticCardNum',
      'diagnosticCardValidUntilDate',
      'contractOsgoppNum',
      'contractOsgoppValidUntilDate',
      'kaskoNum',
      'kaskoValidUntilDate'
    ],
    completed: false,
    check: (values, form) => {
      return values && (
        (
          values.vin &&
          values.gps &&
          values.osagoNum &&
          values.kaskoNum &&
          values.garageNum &&
          values.color &&
          values.doorsAmount &&
          values.engineVolume &&
          values.vehicleWeight &&
          values.driveUnitType &&
          values.engineCapacity &&
          values.vehicleMaxWeight &&
          values.contractOsgoppNum &&
          values.diagnosticCardNum &&
          values.steeringArrangement 
        ) &&
        (
          !hasErrors(form.getFieldsError(['vin'])) &&
          !hasErrors(form.getFieldsError(['osagoNum'])) &&
          !hasErrors(form.getFieldsError(['diagnosticCardNum']))
        )
      )
      ? true : false
    },
    getDescription: (values, props) => {
      // return 'Мест: ' + values.passengerCapacity; // todo добавить Назначение ТС
      return 'VIN: ' + values.vin; //
    },
    button: false,
  },
  /* todo next release
  {
    title: 'Монетизация',
    name: 'monetization',
    fields: ['monetizationNeed', 'submission'],
    completed: false,
    check: (values, form) => {
      if (values.monetizationNeed) return true;
      return !hasErrors(form.getFieldsError(['submission'])) &&
        values.submission
        ? true
        : false;
    },
    getDescription: values => {
      if (values.monetizationNeed) return 'Без монетизации';
      / *
        boolean === true
        ? `Без монетизации`
        : price
        ? `Ставка: ${price * 60} руб./ч`
        : 'ставка не указана';
     * /
    },
    button: false,
  },
  */
  /* todo / this functionality will not be
  {
    title: 'Собственник',
    name: 'owner',
    fields: [
      'vehicleOwner',
      'vehicleOwnerSubject',
      'vehicleOwnerNameLegal',
      'vehicleOwnerAddressLegal',
      'vehicleOwnerInn',
      'vehicleOwnerOgrn',
    ],
    completed: false,
    check: (values, form) => {
      if (values.vehicleOwner) {
        return true;
      } else if (
        !hasErrors(
          form.getFieldsError([
            'vehicleOwnerSubject',
            'vehicleOwnerNameLegal',
            'vehicleOwnerAddressLegal',
            'vehicleOwnerInn',
            'vehicleOwnerOgrn',
          ])
        ) &&
        values.vehicleOwnerNameLegal && values.vehicleOwnerInn
      ) {
        return true;
      }
      return false;
    },
    getDescription: values => {
      return values.vehicleOwnerNameLegal;
    },
    button: false,
  }, */
  /* todo next release
  {
    title: 'Адрес стоянки(гаража)',
    name: 'parking',
    fields: ['parkingAddress'],
    completed: false,
    check: (values, form) => {
      return !hasErrors(form.getFieldsError(['parkingAddress'])) &&
        values.parkingAddress
        ? true
        : false;
    },
    getDescription: (values, { parkingTypes }) => {
      const parkingId = +values.parkingAddress;
      let parking =
        parkingTypes &&
        parkingTypes.find(item => item.vehicleParkingAddressId === parkingId);
      return parking ? parking.parkingAddress : '';
    },
    button: false,
  },*/
  {
    title: 'Закрепленные водители',
    name: 'fixedDrivers',
    fields: ['fixedDrivers'],
    completed: false,
    check: (values, form) => {
      return !hasErrors(form.getFieldsError(['fixedDrivers'])) &&
        values.fixedDrivers &&
        values.fixedDrivers.length > 0
        ? true
        : false;
    },
    getDescription: (values, { profiles }) => {
      return profiles
        .filter(profile => values.fixedDrivers.includes(profile.profileId))
        .map(item => item.userName)
        .join(', ');
    },
    button: false,
  },
  {
    title: 'Ограничения',
    name: 'limitations',
    fields: ['restrictionsServiceTypes'],
    check: (values, form) => {
      return !hasErrors(form.getFieldsError(['restrictionsServiceTypes'])) &&
        values.restrictionsServiceTypes &&
        values.restrictionsServiceTypes.length > 0
        ? true
        : false;
    },
    getDescription: (values, { serviceTypes }) => {
      if (values.restrictionsServiceTypes && serviceTypes) {
        return serviceTypes
          .filter(item =>
            values.restrictionsServiceTypes.includes(item.serviceTypeId)
          )
          .map(item => item.serviceTypeAbbr)
          .join(', ');
      }
    },
    button: false,
  },
  /* todo next release
  {
    title: 'Оснащение',
    name: 'equipment',
    fields: ['offerDocument'],
    getDescription: value => null,
    button: false,
  },
  */
  {
    title: 'Документы',
    name: 'documents',
    fields: ['photoFrontSts', 'photoFrontPts', 'photoBackSts', 'photoBackPts'],
    check: values => {
      return values && 
        values.photoFrontSts ||
        values.photoFrontPts ||
        values.photoBackSts ||
        values.photoBackPts
        ? true : false;
    },
    getDescription: value => null,
    button: false,
  },
  {
    title: 'Фотографии',
    name: 'photo',
    fields: [
      'photo1',
      'photo2',
      'photo3',
      'photo4',
      'photo5',
      'photo6',
      'photo7',
      'photo8',
      'photo9',
      'photo10',
    ],
    check: values => {
      return values && (
        values.photo1 ||
        values.photo2 ||
        values.photo3 ||
        values.photo4 ||
        values.photo5 ||
        values.photo6 ||
        values.photo7 ||
        values.photo8 ||
        values.photo9 ||
        values.photo10
      )
        ? true : false;
    },
    getDescription: value => null,
    button: false,
  },
];

export default progresses;
